"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TraderDocumentTypeChoices = exports.AgencyDocumentTypeChoices = exports.CompanyDocumentTypeChoices = exports.DocumentStatusChoices = void 0;
var DocumentStatusChoices;
(function (DocumentStatusChoices) {
    DocumentStatusChoices["CREATED"] = "created";
    DocumentStatusChoices["VALIDATED"] = "validated";
    DocumentStatusChoices["REJECTED"] = "rejected";
})(DocumentStatusChoices = exports.DocumentStatusChoices || (exports.DocumentStatusChoices = {}));
var CompanyDocumentTypeChoices;
(function (CompanyDocumentTypeChoices) {
    CompanyDocumentTypeChoices["KBIS"] = "kbis";
    CompanyDocumentTypeChoices["IBAN"] = "iban";
})(CompanyDocumentTypeChoices = exports.CompanyDocumentTypeChoices || (exports.CompanyDocumentTypeChoices = {}));
var AgencyDocumentTypeChoices;
(function (AgencyDocumentTypeChoices) {
    AgencyDocumentTypeChoices["RESPONSABILITE_CIVILE_PROFESSIONNELLE"] = "rcp";
    AgencyDocumentTypeChoices["CERTIFICATE"] = "certificate";
})(AgencyDocumentTypeChoices = exports.AgencyDocumentTypeChoices || (exports.AgencyDocumentTypeChoices = {}));
var TraderDocumentTypeChoices;
(function (TraderDocumentTypeChoices) {
    TraderDocumentTypeChoices["ATTESTATION_NON_CONDAMNATION"] = "non_condamnation";
})(TraderDocumentTypeChoices = exports.TraderDocumentTypeChoices || (exports.TraderDocumentTypeChoices = {}));
//# sourceMappingURL=document.js.map